import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
const QuantityLimit = ({product, isCart = false}) => {
    return (
        <Box
            marginTop={isCart ? '0px' : '15px'}
            textAlign="center"
            width={isCart ? 'fit-content' : '100%'}
            className="quantity-limit-box"
        >
            <Text
                className="quantity-limit-text"
                color={isCart ? 'gray.650' : 'red.950'}
                fontWeight="300"
                fontSize="13px"
                letterSpacing="0.065px"
                lineHeight="22px"
            >
                <FormattedMessage
                    id="quantity.limit.max_quantity_per_customer"
                    values={{limit: product.c_orderLimit}}
                    defaultMessage="Max quantity of {limit} per customer"
                />
            </Text>
        </Box>
    )
}

QuantityLimit.propTypes = {
    product: PropTypes.object,
    isCart: PropTypes.bool
}

export default QuantityLimit
